import { render } from "./xfksh.vue?vue&type=template&id=c1713e2a&scoped=true"
import script from "./xfksh.vue?vue&type=script&lang=js"
export * from "./xfksh.vue?vue&type=script&lang=js"

import "./xfksh.vue?vue&type=style&index=0&id=c1713e2a&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1713e2a"]])

export default __exports__